import { render } from "./Objektkennwort.vue?vue&type=template&id=b7218232&scoped=true&ts=true"
import script from "./Objektkennwort.vue?vue&type=script&lang=ts"
export * from "./Objektkennwort.vue?vue&type=script&lang=ts"

import "./Objektkennwort.vue?vue&type=style&index=0&id=b7218232&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7218232"]])

export default __exports__